// src/components/i18n/AutoTranslate.tsx
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * AutoTranslate est volontairement léger.
 * Les anciens lots tentaient de scanner le DOM, ce qui pouvait ralentir les pages lourdes.
 * À partir de ce lot, les nouvelles pages stratégiques utilisent une traduction native FR/EN.
 */
export default function AutoTranslate() {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'fr';
    }
  }, [i18n.language]);

  return null;
}
